"use strict";function bindAlipay$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.bindAlipay$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.alipay.bindAlipay";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.3.15"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.3.15"},_a)),exports.bindAlipay$=bindAlipay$,exports.default=bindAlipay$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/alipay/bindAlipay.js
// module id = 905
// module chunks = 106